import BrowserLogger from "alife-logger";
import { getDeployArea, getDeployEnv, useLoginInfo } from "@ti/max";

const { APP_VERSION } = process.env;
const deployArea = getDeployArea();
const deployEnv = getDeployEnv();

let instance;
export const init = (pid) => {
  // 初始化
  if (["prod"].includes(deployEnv)) {
    const config = {
      sample: 20, // 采样率1-100
      pid,
      appType: "web",
      sendResource: true,
      behavior: true,
      useFmp: true,
      enableSPA: false,
      environment: deployEnv === "prod" ? "prod" : "gray",
      release: APP_VERSION,
      c1: deployEnv,
      c2: deployArea,
      ignore: {
        ignoreUrls: [],
        ignoreErrors: [
          "ResizeObserver loop limit exceeded", // 字符串
          /ResizeObserver loop/, // 正则表达式
          /ResizeObserver loop limit exceeded/, // 正则表达式
          // function(str) { // 方法
          //     if (str && str.indexOf('Unkown error') >= 0) return true;   // 不上报
          //     return false;   // 上报
          // }
        ],
        ignoreApis: [
          function () {
            return false; // 上报
          },
        ],
      },
    };
    if (!window.__bl) {
      instance = BrowserLogger.singleton(config);
    } else {
      if (window.__bl?._conf?.pid === pid) {
        // 已经创建过了需要的pid的实例
        instance = BrowserLogger.singleton(config);
      } else {
        // 创建额外的实例
        instance = BrowserLogger.createExtraInstance(config);
        console.log({ instance });
      }
    }
    getUserInfoAndSetArmsConfig();
  }
};
// pv
export const manualReportPV = (pageName) => {
  instance?.setPage(pageName, true);
};
// 设置
export const setConfig = (next) => {
  instance?.setConfig(next);
};
// 设置用户名
export const setUsername = (username) => {
  instance?.setConfig({
    setUsername() {
      return username;
    },
  });
};

// 手动上报行为
export const manualReportBehavior = (name, massage = "--") => {
  instance?.addBehavior({
    data: {
      name,
      message: massage,
    },
  });
  instance?.reportBehavior();
};

// 自定义统计，均值
export const customerAvg = (key: string, value: number) => {
  instance?.avg(key, value);
};
// 自定义统计 求和
export const customerSum = (key: string, value: number) => {
  instance?.sum(key, value);
};

const getUserInfoAndSetArmsConfig = () => {
  const { userInfo } = useLoginInfo.getState() || {};
  if (userInfo) {
    try {
      instance.setConfig({
        uid: userInfo.userId || userInfo.accountId,
      });
      setUsername(userInfo.userName || userInfo.name);
    } catch {
      return null;
    }
  }
};
